import { Link, Stack } from '@mui/material'
import React from 'react'
import { useTheme } from 'styled-components'
import { Content } from './styles'

function DefaultFooter() {
  const theme = useTheme()

  return (
    <Content>
      <Stack minWidth='100%' minHeight='100%' direction='row' justifyContent='center' alignItems='center' spacing={2}>
        <Link href='https://www.guigo.tv/termos-de-uso/' underline='none' color={theme.colors.primary.main} target='_blank'>
          Termos e condições de uso
        </Link>
        <Link href='https://www.guigo.tv/perguntas-frequentes/' underline='none' color={theme.colors.primary.main} target='_blank'>
          Tire suas dúvidas
        </Link>
      </Stack>
    </Content>
  )
}
export default DefaultFooter
